import React from "react";
import { Outlet } from "react-router-dom";

import Header from "../components/Header";

const DefaultLayout: React.FC = () => {
	return (
		<div className="min-h-screen bg-black">
			<Header />
			<main>
				<Outlet />
			</main>
		</div>
	);
};

export default DefaultLayout;
